import { Box, Divider, Typography } from "@mui/material";
import useColors from "../../../../../../../api/hooks/useColors";

const SlaBreakdown = ({}) => {
  const colors = useColors();
  const mapColorSla = [
    {
      label: "Critical",
      color: colors.cve_critical,
      days: "30",
      score: "9.0-10.0",
    },
    { label: "High", color: colors.cve_high, days: "60", score: "7.0-8.9" },
    // { label: "Medium", color: colors.cve_medium, days: "90", score: "4.0-6.9" },
    // { label: "Low", color: colors.cve_low, score: "0.1-3.9" },
  ];
  return (
    <Box
      sx={{
        display: "flex",
        width: "200px",
        flexDirection: "column",
        padding: "16px",
      }}
    >
      <Typography variant="subtitle2">SLA Breakdown</Typography>
      <Divider sx={{ margin: "8px 0" }} />
      {mapColorSla.map((sla) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginBottom: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "6px",
              flexDirection: "column",
              alignItems: "flex-start",
              alignSelf: "stretch",
              borderRadius: "2px",
              backgroundColor: sla.color,
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="overline"
                sx={{
                  color: colors.text_primary,
                  fontWeight: 500,
                  marginLeft: "8px",
                }}
              >
                {sla.label}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: colors.text_secondary,
                  fontWeight: 400,
                  marginLeft: "8px",
                }}
              >
                {sla.score}
              </Typography>
            </Box>
            <Typography
              variant="caption"
              sx={{
                color: colors.text_secondary,
                fontWeight: 400,
                marginLeft: "8px",
              }}
            >
              {sla.days ? `${sla.days} days` : "Capacity based"}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SlaBreakdown;
